export class CreditHoldActionFilter {
    public IncludeInactive?: boolean;
}

export default CreditHoldActionFilter;